"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestTemplateModal = exports.CopyTemplateModal = exports.UpdateTemplateModal = exports.CreateTemplateModal = void 0;
var React = require("react");
var Snackbar_1 = require("../../components/common/Snackbar");
var material_1 = require("@mui/material");
var react_1 = require("react");
var AppContext_1 = require("../../context/AppContext");
var LoadingModal_1 = require("../../components/common/LoadingModal");
var templatePicker_1 = require("../../components/email/templatePicker");
var api_1 = require("../../api/api");
var icons_material_1 = require("@mui/icons-material");
var editor_1 = require("../../components/email/editor");
var AddCircleOutlined_1 = require("@mui/icons-material/AddCircleOutlined");
var CheckBox_1 = require("@mui/icons-material/CheckBox");
var SaveOutlined_1 = require("@mui/icons-material/SaveOutlined");
var Delete_1 = require("@mui/icons-material/Delete");
var BugReportSharp_1 = require("@mui/icons-material/BugReportSharp");
var sxProp_1 = require("../../assets/styles/sxProp");
var KVPTable_1 = require("../../components/common/KVPTable");
var SMSTemplateCreate = function () {
    var _a = (0, react_1.useContext)(AppContext_1.default), lob = _a.lob, userRole = _a.userRole;
    var _b = (0, react_1.useState)(""), projectId = _b[0], setProjectId = _b[1];
    var _c = (0, react_1.useState)(false), dialogOpenCreate = _c[0], setDialogOpenCreate = _c[1];
    var _d = (0, react_1.useState)(false), dialogOpenUpdate = _d[0], setDialogOpenUpdate = _d[1];
    var _e = (0, react_1.useState)(false), dialogOpenCopy = _e[0], setDialogOpenCopy = _e[1];
    var _f = (0, react_1.useState)(false), dialogOpenTest = _f[0], setDialogOpenTest = _f[1];
    var _g = (0, react_1.useState)(false), dialogOpenSave = _g[0], setDialogOpenSave = _g[1];
    var _h = (0, react_1.useState)(false), alertOpen = _h[0], setAlertOpen = _h[1];
    var _j = (0, react_1.useState)(""), alertMessage = _j[0], setAlertMessage = _j[1];
    var _k = (0, react_1.useState)(), alertSeverity = _k[0], setAlertSeverity = _k[1];
    var _l = (0, react_1.useState)(false), loading = _l[0], setLoading = _l[1];
    var _m = (0, react_1.useState)([]), _smsTemplates = _m[0], _setSmsTemplates = _m[1];
    var _o = (0, react_1.useState)([]), _templateList = _o[0], _setTemplateList = _o[1];
    var _p = (0, react_1.useState)(""), _chosenTemplate = _p[0], _setChosenTemplate = _p[1];
    var _q = (0, react_1.useState)(""), _activeVersion = _q[0], _setActiveVersion = _q[1];
    var _r = (0, react_1.useState)(""), _chosenTemplateVersion = _r[0], _setChosenTemplateVersion = _r[1];
    var _s = (0, react_1.useState)(""), _code = _s[0], _setCode = _s[1];
    var _t = (0, react_1.useState)([]), _smsTemplateVersions = _t[0], _setSmsTemplateVersions = _t[1];
    var _u = (0, react_1.useState)(null), _smsDetails = _u[0], _setSmsDetails = _u[1];
    var _v = (0, react_1.useState)(""), _dupTemplateName = _v[0], _setDupTemplateName = _v[1];
    var _w = (0, react_1.useState)({}), updateTemp = _w[0], setUpdateTemp = _w[1];
    var _x = (0, react_1.useState)(false), newVersion = _x[0], setNewVersion = _x[1];
    var _y = (0, react_1.useState)(false), latestVersionFlag = _y[0], setLatestVersionFlag = _y[1];
    var _z = (0, react_1.useState)(""), latestVersionNumber = _z[0], setLatestVersionNumber = _z[1];
    var _0 = (0, react_1.useState)({}), editFlag = _0[0], setEditFlag = _0[1];
    var _1 = (0, react_1.useState)(false), modifiedFlag = _1[0], setModifiedFlag = _1[1];
    var _2 = (0, react_1.useState)(false), invalidInput = _2[0], setInvalidInput = _2[1];
    var _3 = (0, react_1.useState)("9rem"), minWidth = _3[0], setMinWidth = _3[1];
    var _4 = (0, react_1.useState)("50px"), descriptionHeight = _4[0], setDescriptionHeight = _4[1];
    var _5 = (0, react_1.useState)(""), previewCode = _5[0], setPreviewCode = _5[1];
    (0, react_1.useEffect)(function () {
        if (lob) {
            (0, api_1.getProject)(lob).then(function (res) {
                setProjectId(res.projectId);
            });
        }
    }, [lob, userRole]);
    (0, react_1.useEffect)(function () {
        getTemplates("");
        displayCurrentTemplate("New Template");
        _setChosenTemplate("New Template");
        setUpdateTemp({});
    }, [lob, userRole]);
    (0, react_1.useEffect)(function () {
        _setCode(_smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.body);
    }, [_chosenTemplate, _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.body]);
    (0, react_1.useEffect)(function () {
        _setTemplateList(_templateList);
    }, [_templateList]);
    (0, react_1.useEffect)(function () {
        if (_smsDetails) {
            var isModified = _smsDetails.templateDescription !== updateTemp.description ||
                _smsDetails.body !== updateTemp.content;
            setModifiedFlag(isModified);
        }
    }, [updateTemp, _smsDetails]);
    /*    useEffect(() => {
            if (_smsDetails) {
                console.log("useEffect - _smsDetails.defaultSubstitutions - updateTemp: ", _smsDetails.defaultSubstitutions);
            }
            console.log("useEffect - updateTemp, ", updateTemp);
        }, [updateTemp])*/
    /*    useEffect(() => {
            if (_smsDetails) {
                console.log("useEffect - _smsDetails.defaultSubstitutions - _smsDetails: ", _smsDetails.defaultSubstitutions);
            }
        }, [_smsDetails])*/
    /*    useEffect(() => {
            _setCode(_code);
        }, [_setCode])*/
    /*useEffect(() => {
        //if (previewCode) {
            //setPreviewCode(previewCode);
        console.log("useEffect - previewCode: ", previewCode ? previewCode : "No previewCode");
        // setPreviewCode(previewCode);

        //}
    }, [previewCode])

    useEffect(() => {
        console.log("useEffect - _code: ", _code ? _code : "No _code");
    }, [_code])

    useEffect(() => {
        console.log("useEffect - _smsDetails: ", _smsDetails ? _smsDetails : "No _smsDetails");
    }, [_smsDetails])*/
    (0, react_1.useEffect)(function () {
        var maxWidth = 70;
        if (updateTemp) {
            if (updateTemp.description) {
                var maxLength = updateTemp.description.length;
                var row = 1;
                maxLength = updateTemp.description ? updateTemp.description.length : 20;
                var newWidth = (maxLength > 25) ? (Math.max(150, maxLength * 10)) / 16 : 250 / 16;
                newWidth < maxWidth ? (newWidth < 25 ? setMinWidth("30rem") : setMinWidth(String(newWidth) + "rem")) : setMinWidth("70rem");
                if (updateTemp.description) {
                    row = Math.min(3, updateTemp.description.split('\n').length);
                    if (row === 1) {
                        if (newWidth < maxWidth) {
                            setDescriptionHeight("50px");
                        }
                        else if ((newWidth >= maxWidth) && (newWidth < (2 * maxWidth))) {
                            setDescriptionHeight("72px");
                        }
                        else {
                            setDescriptionHeight("95px");
                        }
                    }
                    else if (row === 2) {
                        var splitedDescription = updateTemp.description.split('\n');
                        var maxLengthDescription = Math.max(splitedDescription[0].length, splitedDescription[1].length);
                        if ((maxLengthDescription * 10 / 16) > maxWidth) {
                            setDescriptionHeight("95px");
                        }
                        else {
                            setDescriptionHeight("72px");
                        }
                    }
                    else {
                        setDescriptionHeight("95px");
                    }
                }
            }
            else {
                setMinWidth("15rem");
            }
        }
    }, [_smsDetails, updateTemp]);
    var toggleCopyTemplate = function () {
        _setDupTemplateName(_smsDetails.templateName + "-COPY");
    };
    var _onTemplateChange = function (option) { return __awaiter(void 0, void 0, void 0, function () {
        var latestVersion, _details;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInvalidInput(false);
                    latestVersion = "";
                    if (!(option.value === "New Template")) return [3 /*break*/, 1];
                    _setSmsTemplateVersions([]);
                    _setChosenTemplateVersion("");
                    _setActiveVersion("");
                    _setSmsDetails(null);
                    _setCode("Please enter text.");
                    _setChosenTemplate("New Template");
                    setNewVersion(false);
                    setDialogOpenSave(false);
                    setUpdateTemp({});
                    setPreviewCode("Please enter text.");
                    return [3 /*break*/, 3];
                case 1:
                    _setChosenTemplateVersion("1");
                    return [4 /*yield*/, (0, api_1.getTemplateByName)(option.value, "SMS")];
                case 2:
                    _details = _a.sent();
                    if (_details && option.value !== "New Template") {
                        setUpdateTemp(function (prev) { return (__assign(__assign({}, prev), { description: _details.templateDescription, content: _details.body })); });
                        setEditFlag(function (prev) { return (__assign(__assign({}, prev), { description: false, content: false })); });
                        getVersions(option.value)
                            .then(function (res) {
                            latestVersion = res[res.length - 1].label;
                            return _setSmsTemplateVersions(res);
                        }).then(function () {
                            _setChosenTemplateVersion(_details.version);
                            _setActiveVersion(_details.version);
                            setLatestVersionFlag(Number(_details.version) === Number(latestVersion));
                            setNewVersion(Number(_details.version) !== Number(latestVersionNumber));
                            return;
                        });
                        /*.then(() => {
                            return getTemplateDetails(option.value);
                        })*/
                        _setSmsDetails(_details);
                        _setCode(_details.body);
                        _setChosenTemplate(option.value);
                        setPreviewCode(_details.body);
                    }
                    else {
                        _setSmsTemplateVersions([]);
                        _setChosenTemplateVersion("");
                        _setActiveVersion("");
                        _setSmsDetails(null);
                        _setCode('Please enter text.');
                        _setChosenTemplate("New Template");
                        setNewVersion(false);
                        setDialogOpenSave(false);
                        setPreviewCode("Please enter text.");
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _onVersionChange = function (option) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setInvalidInput(false);
                    return [4 /*yield*/, (0, api_1.getTemplateByNameVersion)(_smsDetails.templateName, option.value, "SMS")];
                case 1:
                    res = _a.sent();
                    setUpdateTemp(function (prev) { return (__assign(__assign({}, prev), { description: res.templateDescription, content: res.body, version: res.version })); });
                    _setChosenTemplateVersion(option.value);
                    _setSmsDetails(res);
                    _setCode(res.body);
                    setPreviewCode(res.body);
                    setLatestVersionFlag(Number(option.value) === Number(latestVersionNumber));
                    setNewVersion(Number(option.value) !== Number(latestVersionNumber));
                    setDialogOpenSave(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var _onCodeChange = function (code) {
        console.log("inside code change");
        _setCode(code || '');
        setUpdateTemp(function (prev) { return (__assign(__assign({}, prev), { content: code || '' })); });
        setPreviewCode(code || '');
    };
    var getTemplates = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var res, defaultTemplate, templateList, sortedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, (0, api_1.getAllLobTemplates)(lob, "SMS")];
                case 1:
                    res = _a.sent();
                    _setSmsTemplates(res);
                    defaultTemplate = { label: "New Template", value: "New Template" };
                    if (res && res.status !== 400) {
                        templateList = res.map(function (item) {
                            return {
                                label: item.templateName,
                                value: item.templateName
                            };
                        });
                        templateList.push(defaultTemplate);
                        sortedList = templateList.sort(function (a, b) { return (a.label < b.label ? -1 : 1); });
                        _setTemplateList(sortedList);
                    }
                    setLoading(false);
                    if (value === "") {
                        _setChosenTemplate("New Template");
                    }
                    else {
                        _setChosenTemplate(value);
                    }
                    setEditFlag({});
                    setModifiedFlag(false);
                    return [2 /*return*/];
            }
        });
    }); };
    /*    const getTemplateDetails = async (name: string) => {
            var res = await getTemplateByName(name, "SMS");
            console.log("getTemplateDetails ", res);
            _setSmsDetails(res);
            _setCode(res.body);
        }*/
    var getVersions = function (name) { return __awaiter(void 0, void 0, void 0, function () {
        var templateType, res, versionList, sortedList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    templateType = "SMS";
                    return [4 /*yield*/, (0, api_1.getTemplateVersions)(name, templateType)];
                case 1:
                    res = _a.sent();
                    if (res.item && res.item.length > 0) {
                        versionList = res.item.map(function (item) {
                            return {
                                label: item.version,
                                value: item.version
                            };
                        });
                        sortedList = versionList.sort(function (a, b) { return (Number(a.label) < Number(b.label) ? -1 : 1); });
                        setLatestVersionNumber(sortedList[sortedList.length - 1].label);
                        return [2 /*return*/, sortedList];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var displayCurrentTemplate = function (values) {
        var displayTemplate = {};
        displayTemplate["label"] = values;
        displayTemplate["value"] = values;
        _onTemplateChange(displayTemplate);
    };
    var saveTemplate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var name, description, content, defaultSub, attributes, def, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = values.name;
                    description = values.description;
                    content = _code;
                    defaultSub = values.defaultSubstitutions;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    attributes = {
                        CITY_: "",
                        STATE_: "",
                        ZIP_: ""
                    };
                    def = JSON.stringify(attributes);
                    return [4 /*yield*/, (0, api_1.createSmsTemplate)(lob, name, content, description, defaultSub)];
                case 2:
                    response = _a.sent();
                    setAlertSeverity("success");
                    setAlertMessage("Template was created Successfully");
                    setAlertOpen(true);
                    // reload the created template    
                    getTemplates(name);
                    displayCurrentTemplate(values.name);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.log(err_1);
                    setAlertSeverity("error");
                    setAlertMessage("Unable to create template!");
                    setAlertOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateTemplate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var name, description, content, newVersion, attributes, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = values.name;
                    description = values.description;
                    content = _code;
                    newVersion = values.newVersion;
                    attributes = values.defaultSubstitutions;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, api_1.updateSmsTemplate)(name, content, newVersion, description, attributes)];
                case 2:
                    _a.sent();
                    setAlertSeverity("success");
                    setAlertMessage("Template was update Successfully");
                    setAlertOpen(true);
                    // reload the current page with the copied template
                    getTemplates(name);
                    displayCurrentTemplate(values.name);
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    console.log(err_2);
                    setAlertSeverity("error");
                    setAlertMessage("Unable to update template!");
                    setAlertOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var copyTemplate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var name, description, content, defaultSub, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = values.name;
                    description = values.description;
                    content = _code;
                    defaultSub = values.defaultSubstitutions;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, api_1.createSmsTemplate)(lob, name, content, description, defaultSub)];
                case 2:
                    _a.sent();
                    setAlertSeverity("success");
                    setAlertMessage("Template was created Successfully");
                    setAlertOpen(true);
                    // reload the current page with the copied template
                    getTemplates(name);
                    displayCurrentTemplate(values.name);
                    return [3 /*break*/, 4];
                case 3:
                    err_3 = _a.sent();
                    console.log(err_3);
                    setAlertSeverity("error");
                    setAlertMessage("Unable to create template!");
                    setAlertOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var deleteTemplate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var name, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateName;
                    if (!!window.confirm("Are you sure you want to delete ".concat(name, "? This action is irreversible!"))) return [3 /*break*/, 1];
                    return [2 /*return*/];
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, api_1.deleteTemplateByName)(name, lob, "SMS")];
                case 2:
                    _a.sent();
                    setAlertSeverity("success");
                    setAlertMessage("Template was deleted Successfully");
                    setAlertOpen(true);
                    // reload the default template 
                    getTemplates("");
                    displayCurrentTemplate("New Template");
                    _setChosenTemplate("New Template");
                    return [3 /*break*/, 4];
                case 3:
                    err_4 = _a.sent();
                    console.log(err_4);
                    setAlertSeverity("error");
                    setAlertMessage("Unable to delete template!");
                    setAlertOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var testTemplate = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var appId, templateName, description, content, defaultSubstitutions, smsTo, smsFrom, messageType, temp, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appId = values.appId;
                    templateName = values.name;
                    description = values.description;
                    content = _code;
                    defaultSubstitutions = values.defaultSubstitutions;
                    smsTo = values.sendSmsTo;
                    smsFrom = values.sendSmsFrom;
                    messageType = values.messageType;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, api_1.testSmsTemplate)(appId, templateName, content, smsTo, smsFrom, defaultSubstitutions, messageType, description)
                            .then(function (r) {
                            return r;
                        })];
                case 2:
                    temp = _a.sent();
                    if (temp === 200) {
                        setAlertSeverity("success");
                        setAlertMessage("Template was tested Successfully");
                        setAlertOpen(true);
                    }
                    else {
                        setAlertSeverity("error");
                        setAlertMessage("Unable to test template!");
                        setAlertOpen(true);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _a.sent();
                    console.log(err_5);
                    setAlertSeverity("error");
                    setAlertMessage("Unable to test template!");
                    setAlertOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var makeActive = function () { return __awaiter(void 0, void 0, void 0, function () {
        var name, ver, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    name = _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateName;
                    ver = _chosenTemplateVersion;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, api_1.activateTemplate)(name, ver, "SMS")];
                case 2:
                    _a.sent();
                    setAlertSeverity("success");
                    setAlertMessage("Version " + ver + " is now active!");
                    setAlertOpen(true);
                    getTemplates(name);
                    displayCurrentTemplate(name);
                    return [3 /*break*/, 4];
                case 3:
                    err_6 = _a.sent();
                    console.log(err_6);
                    setAlertSeverity("error");
                    setAlertMessage("Unable to change active version!");
                    setAlertOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleUpdateTempChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setUpdateTemp(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
        /*if (name === "subject" && !value) {
            setInvalidInput(true);
        }*/
    };
    var handleUpdateEdit = function (e) {
        var name = e.target.name;
        setEditFlag(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = true, _a)));
        });
    };
    var handleUpdateConfirmEdit = function (input, newVersion) {
        if (!invalidInput) {
            var values = {
                name: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateName,
                description: input.description || "",
                content: input.content,
                newVersion: newVersion,
                defaultSubstitutions: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.defaultSubstitutions
            };
            if (modifiedFlag) {
                updateTemplate(values);
            }
            setEditFlag({});
            setDialogOpenSave(false);
        }
    };
    var handleUpdateCancelEdit = function (e, name) {
        if (name === "description") {
            setUpdateTemp(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails["templateDescription"], _a)));
            });
        }
        else {
            setUpdateTemp(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails[name], _a)));
            });
        }
        setEditFlag(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = false, _a)));
        });
        // setInvalidInput(false);
    };
    var handleOpenSaveDialog = function () {
        setNewVersion(!latestVersionFlag);
        setDialogOpenSave(true);
    };
    var handleCloseSaveDialog = function () {
        setDialogOpenSave(false);
    };
    var toggleNewVersion = function () {
        setNewVersion(!newVersion);
    };
    var handleOnParse = function (previewCode) {
        setPreviewCode(previewCode);
    };
    /*    const handleOnParse = (newCode: string) => {
            _setCode(newCode);
        }*/
    return (React.createElement(React.Fragment, null,
        React.createElement(LoadingModal_1.default, { open: loading }),
        React.createElement(material_1.Grid, null,
            React.createElement("div", { className: "App" },
                React.createElement("div", { className: 'm-2 flex justify-start' },
                    (Array.isArray(_templateList) && _templateList.length > 0) ?
                        React.createElement(templatePicker_1.default, { options: _templateList, onChange: _onTemplateChange, selected: { label: _chosenTemplate, value: _chosenTemplate }, label: "Template" })
                        : React.createElement(React.Fragment, null),
                    "\u00A0",
                    (Array.isArray(_smsTemplateVersions) && _smsTemplateVersions.length > 0) ?
                        React.createElement(templatePicker_1.default, { options: _smsTemplateVersions, onChange: _onVersionChange, selected: { label: _chosenTemplateVersion, value: _chosenTemplateVersion }, label: "Versions" })
                        : React.createElement(React.Fragment, null)),
                React.createElement("div", { className: 'm-2 flex justify-start' }, (_smsDetails) ?
                    React.createElement("div", null,
                        React.createElement(material_1.Grid, { container: true, item: true, spacing: 1 },
                            React.createElement(material_1.Grid, { item: true, xs: 12 },
                                React.createElement(material_1.TextField, { id: "description", name: "description", label: "Description", sx: { minWidth: minWidth, height: descriptionHeight, wordWrap: 'break-word', maxWidth: '100%' }, size: "small", variant: "outlined", multiline: true, maxRows: 3, InputLabelProps: {
                                        shrink: true,
                                    }, onChange: handleUpdateTempChange, value: updateTemp.description || "", onFocus: function (e) { return handleUpdateEdit(e); }, fullWidth: true, disabled: false, placeholder: "Optional", InputProps: {
                                        endAdornment: (React.createElement(material_1.InputAdornment, { position: "end" }, editFlag["description"] && !invalidInput && modifiedFlag && (React.createElement(material_1.Tooltip, { title: "Cancel?" },
                                            React.createElement(material_1.IconButton, { onClick: function (e) { return handleUpdateCancelEdit(e, "description"); } },
                                                React.createElement(icons_material_1.Close, null))))))
                                    } }))),
                        React.createElement(material_1.Grid, { container: true, item: true, spacing: 1 },
                            React.createElement(material_1.Grid, { item: true, xs: 4, container: true, justifyContent: 'flex-start' },
                                React.createElement(material_1.TextField, { id: "version", label: "Version", sx: { width: '6rem', height: '50px' }, size: "small", variant: "outlined", InputLabelProps: {
                                        shrink: true,
                                    }, value: _smsDetails.version || "", fullWidth: true, disabled: true })),
                            React.createElement(material_1.Grid, { item: true, xs: 8, container: true, alignItems: 'center', justifyContent: 'flex-start' }, (_smsDetails.version === _activeVersion) ?
                                React.createElement(material_1.Chip, { icon: React.createElement(icons_material_1.CheckCircle, null), label: "Active", color: "success" }) : React.createElement(React.Fragment, null))))
                    : React.createElement(React.Fragment, null)),
                React.createElement("div", { className: 'm-2 flex justify-start' },
                    (_chosenTemplate === "New Template") ?
                        React.createElement(React.Fragment, null,
                            React.createElement(material_1.Tooltip, { title: 'Create' },
                                React.createElement(material_1.IconButton, { onClick: function () { return setDialogOpenCreate(true); } },
                                    React.createElement(AddCircleOutlined_1.default, { sx: { variant: "outlined", color: 'green' } }),
                                    " ")))
                        :
                            React.createElement(React.Fragment, null,
                                modifiedFlag && !invalidInput && (React.createElement(React.Fragment, null,
                                    React.createElement(material_1.Tooltip, { title: 'Save' },
                                        React.createElement(material_1.IconButton, { onClick: handleOpenSaveDialog },
                                            React.createElement(CheckBox_1.default, { sx: { variant: "outlined", color: 'green' } }),
                                            " ")),
                                    React.createElement(material_1.Dialog, { open: dialogOpenSave, onClose: handleCloseSaveDialog },
                                        React.createElement(material_1.DialogTitle, null,
                                            React.createElement(material_1.Typography, { variant: 'inherit', sx: { fontFamily: sxProp_1.dishFont, display: 'flex' } }, "Update SMS Template: "),
                                            React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont, display: 'flex' } },
                                                React.createElement("br", null),
                                                "Template Name: ",
                                                _chosenTemplate,
                                                " "),
                                            React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont, display: 'flex' } },
                                                "Current Version: ",
                                                _chosenTemplateVersion,
                                                " "),
                                            latestVersionFlag ?
                                                React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } },
                                                    React.createElement(material_1.Checkbox, { onChange: toggleNewVersion, checked: newVersion }),
                                                    !newVersion ? "Create New Version" : ("This will create version " + (Number(latestVersionNumber) + 1)))
                                                :
                                                    React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont, display: 'flex', color: 'red' } },
                                                        React.createElement("br", null),
                                                        " This will create version  ",
                                                        Number(latestVersionNumber) + 1)),
                                        React.createElement(material_1.DialogActions, null,
                                            React.createElement(material_1.Button, { sx: sxProp_1.buttonSecondary, onClick: handleCloseSaveDialog }, "Cancel"),
                                            React.createElement(material_1.Button, { sx: sxProp_1.buttonPrimary, variant: "contained", onClick: function () { return handleUpdateConfirmEdit(updateTemp, newVersion); } }, latestVersionFlag ? (!newVersion ? "Update" : "Save as New Version") : "Save as New Version"))))),
                                React.createElement(material_1.Tooltip, { title: 'Update' },
                                    React.createElement(material_1.IconButton, { onClick: function () { return setDialogOpenUpdate(true); } },
                                        React.createElement(SaveOutlined_1.default, { sx: { variant: "outlined", color: 'blue' } }),
                                        " "))),
                    (_chosenTemplate !== "New Template") ?
                        React.createElement(React.Fragment, null,
                            React.createElement(material_1.Tooltip, { title: 'Copy' },
                                React.createElement(material_1.IconButton, { onClick: function () { setDialogOpenCopy(true); toggleCopyTemplate(); } },
                                    React.createElement(icons_material_1.ContentCopy, { sx: { variant: "outlined", color: 'blue' } }),
                                    " ")),
                            React.createElement(material_1.Tooltip, { title: 'Delete' },
                                React.createElement(material_1.IconButton, { onClick: deleteTemplate },
                                    React.createElement(Delete_1.default, { sx: { variant: "outlined", color: 'red' } }),
                                    " ")),
                            (Number(_activeVersion) === Number(_chosenTemplateVersion)) && (React.createElement(material_1.Tooltip, { title: 'Test' },
                                React.createElement(material_1.IconButton, { onClick: function () { return setDialogOpenTest(true); } },
                                    React.createElement(BugReportSharp_1.default, { sx: { variant: "outlined", color: 'purple' } }),
                                    " "))),
                            ((_smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.version) !== _activeVersion) ?
                                React.createElement(React.Fragment, null,
                                    React.createElement(material_1.Tooltip, { title: 'Mark Active' },
                                        React.createElement(material_1.IconButton, { onClick: makeActive },
                                            React.createElement(icons_material_1.Verified, { sx: { variant: "outlined", color: 'green' } })))) : React.createElement(React.Fragment, null)) : React.createElement(React.Fragment, null)),
                React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont, display: 'flex' } },
                    "Total of ",
                    previewCode ? previewCode.length : ((updateTemp.content || updateTemp.content === '') ? updateTemp.content.length : 'Please enter text.'.length),
                    " characters contained pre-populating default values of attributes. "),
                React.createElement("div", { className: 'grid grid-cols-2 h-screen' },
                    React.createElement("div", { className: 'col-span-1 h-2/3 max-h-2/3 overflow-auto' },
                        "                            ",
                        React.createElement(editor_1.default, { code: _code, onChange: _onCodeChange, templateType: "SMS" })),
                    _code &&
                        React.createElement("div", { className: 'col-span-1 h-2/3 max-h-2/3 overflow-auto items-start', style: { marginLeft: '20px' } },
                            React.createElement(material_1.Divider, { variant: "middle" },
                                React.createElement(material_1.Typography, { variant: "caption", sx: { fontFamily: sxProp_1.dishFont, fontSize: '24px' } }, "Message Preview")),
                            React.createElement(material_1.Box, null))))),
        React.createElement(exports.CreateTemplateModal, { open: dialogOpenCreate, onClose: function () { setDialogOpenCreate(false); }, onSubmit: saveTemplate, currentBody: _code, currentLob: lob }),
        React.createElement(exports.UpdateTemplateModal, { open: dialogOpenUpdate, onClose: function () { setDialogOpenUpdate(false); }, onSubmit: updateTemplate, currentName: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateName, currentDescription: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateDescription, currentDefaultSubstitutions: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.defaultSubstitutions, currentVersion: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.version, currentBody: _code, currentSmsDetails: _smsDetails, currentLob: lob, latestVersionFlag: latestVersionFlag, latestVersionNumber: latestVersionNumber }),
        React.createElement(exports.CopyTemplateModal, { open: dialogOpenCopy, onClose: function () { setDialogOpenCopy(false); }, onSubmit: copyTemplate, currentName: _dupTemplateName, currentDescription: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateDescription, currentDefaultSubstitutions: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.defaultSubstitutions, currentBody: _code, currentLob: lob }),
        React.createElement(exports.TestTemplateModal, { open: dialogOpenTest, onClose: function () { setDialogOpenTest(false); }, onSubmit: testTemplate, currentName: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateName, currentDescription: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.templateDescription, currentDefaultSubstitutions: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.defaultSubstitutions, currentBody: _smsDetails === null || _smsDetails === void 0 ? void 0 : _smsDetails.body, currentProjectId: projectId }),
        React.createElement(Snackbar_1.default, { open: alertOpen, severity: alertSeverity, message: alertMessage, onClose: function () { return setAlertOpen(false); } })));
};
;
var CreateTemplateModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, currentBody = _a.currentBody, currentLob = _a.currentLob;
    var isTestModal = (0, react_1.useState)(false)[0];
    var _b = (0, react_1.useState)(""), name = _b[0], setName = _b[1];
    var _c = (0, react_1.useState)(""), description = _c[0], setDescription = _c[1];
    var _d = (0, react_1.useState)(currentLob), lob = _d[0], setLob = _d[1];
    var _e = (0, react_1.useState)({
        noName: 0,
        hasSpaces: 0,
        noValue: 0,
    }), validationErrors = _e[0], setValidationErrors = _e[1];
    var _f = (0, react_1.useState)(""), kvps = _f[0], setKvps = _f[1];
    var handleKvpChange = function (newKvps) {
        setKvps(newKvps);
    };
    var _g = (0, react_1.useState)(false), noValueFlag = _g[0], setNoValueFlag = _g[1];
    var handleNoValueFlag = function (newFlag) {
        setNoValueFlag(newFlag);
    };
    // nameSubjectFlag[0]: check for no name
    // nameSubjectFlag[1]: check for space in name
    var _h = (0, react_1.useState)([0, 0]), nameErrorFlag = _h[0], setNameErrorFlag = _h[1];
    (0, react_1.useEffect)(function () {
        setLob(currentLob);
    }, [currentLob, open]);
    (0, react_1.useEffect)(function () {
        setNoValueFlag(noValueFlag);
    }, [noValueFlag]);
    (0, react_1.useEffect)(function () {
        setName(name);
    }, [name]);
    (0, react_1.useEffect)(function () {
        setNameErrorFlag(nameErrorFlag);
    }, [nameErrorFlag]);
    var details = {
        name: name,
        description: description,
        defaultSubstitutions: kvps,
        lob: lob,
    };
    var updateTemplateName = function (e) {
        setName(e.target.value);
        var errorFlag = [0, 0];
        if (!e.target.value.trim()) {
            errorFlag[0] = 1;
        }
        else if (/\s/g.test(e.target.value)) {
            errorFlag[1] = 1;
        }
        setNameErrorFlag(errorFlag);
    };
    var updateTemplateDescription = function (e) {
        setDescription(e.target.value);
    };
    var handleCancel = function () {
        setValidationErrors({
            noName: 0,
            hasSpaces: 0
        });
        setName("");
        setDescription("");
        setValidationErrors({});
        setNoValueFlag(false);
        setKvps("");
        setNameErrorFlag([0, 0]);
        onClose();
    };
    var checkForSpaces = function (value) {
        if (value)
            return /\s/g.test(value);
    };
    var handleSubmit = function () {
        function validator() {
            return __awaiter(this, void 0, void 0, function () {
                var newErrorObject;
                return __generator(this, function (_a) {
                    newErrorObject = {
                        noName: 0,
                        hasSpaces: 0,
                        noValue: 0,
                    };
                    if (!name) {
                        newErrorObject.noName = 1;
                    }
                    if (checkForSpaces(name)) {
                        newErrorObject.hasSpaces = 1;
                    }
                    if (noValueFlag) {
                        newErrorObject.noValue = 1;
                    }
                    setValidationErrors(newErrorObject);
                    if (newErrorObject.noName === 1) {
                        console.log("Missing Template Name");
                        return [2 /*return*/, null];
                    }
                    else if (newErrorObject.hasSpaces === 1) {
                        console.log("Contains Spaces");
                        return [2 /*return*/, null];
                    }
                    else if (!isTestModal && newErrorObject.noValue === 1) {
                        console.log("Missing Values for Attributess");
                        setNoValueFlag(true);
                        return [2 /*return*/, null];
                    }
                    else {
                        details = {
                            name: name,
                            description: description,
                            defaultSubstitutions: kvps,
                            lob: lob,
                        };
                        console.log("Values before OnSubmit (Create): ", details);
                        onSubmit(details);
                        setName("");
                        setDescription("");
                        setValidationErrors({});
                        setNoValueFlag(false);
                        setKvps("");
                        setNameErrorFlag([0, 0]);
                        onClose();
                    }
                    return [2 /*return*/];
                });
            });
        }
        validator();
    };
    return (React.createElement(material_1.Dialog, { open: open },
        React.createElement(material_1.DialogTitle, { textAlign: "center" }, "Create SMS Template"),
        React.createElement(material_1.DialogContent, null,
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(material_1.Stack, { sx: {
                        width: '100%',
                        minWidth: { xs: '300px', sm: '360px', md: '400px' },
                        gap: '1.5rem',
                    } },
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Template Name"),
                        React.createElement(material_1.TextField, { id: "templatName", sx: { minWidth: '16rem', width: "93%" }, onChange: updateTemplateName, value: name || "", error: name === "" || nameErrorFlag[0] === 1 || nameErrorFlag[1] === 1, helperText: ((name === "" || nameErrorFlag[0] === 1) ? "Please enter a valid Template Name" : "") || ((name === "" || nameErrorFlag[1] === 1) ? "Template Name Contains Spaces" : ""), fullWidth: true }),
                        validationErrors.noName === 1 &&
                            React.createElement(material_1.Typography, { key: 'NameError', sx: sxProp_1.errorText }, "Please enter a Template Name"),
                        validationErrors.hasSpaces === 1 &&
                            React.createElement(material_1.Typography, { key: 'NameError', sx: sxProp_1.errorText }, "Template Name cannot contain spaces")),
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Description"),
                        React.createElement(material_1.TextField, { id: "description", sx: { minWidth: '16rem', width: "93%" }, placeholder: "Optional", onChange: updateTemplateDescription, value: description || "", fullWidth: true })),
                    React.createElement(KVPTable_1.default, { kvps: kvps, newList: [], keyName: "Variable Name", keyLabel: "Value", onKvpChange: handleKvpChange, onNoValueFlagChange: handleNoValueFlag, emailHtmlPart: currentBody, valueCheckAlert: !isTestModal, subject: "" })))),
        React.createElement(material_1.DialogActions, { sx: { p: '1.25rem' } },
            React.createElement(material_1.Button, { sx: sxProp_1.buttonSecondary, onClick: handleCancel }, "Cancel"),
            React.createElement(material_1.Tooltip, { title: !isTestModal ? "Missing Values" : "", disableHoverListener: !noValueFlag },
                React.createElement("span", null,
                    React.createElement(material_1.Button, { sx: sxProp_1.buttonPrimary, onClick: handleSubmit, variant: "contained", disabled: name === "" || nameErrorFlag[0] === 1 || nameErrorFlag[1] === 1 || (!isTestModal && noValueFlag) }, "Create"))))));
};
exports.CreateTemplateModal = CreateTemplateModal;
;
var UpdateTemplateModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, currentName = _a.currentName, currentDescription = _a.currentDescription, currentDefaultSubstitutions = _a.currentDefaultSubstitutions, currentVersion = _a.currentVersion, currentBody = _a.currentBody, currentSmsDetails = _a.currentSmsDetails, currentLob = _a.currentLob, latestVersionFlag = _a.latestVersionFlag, latestVersionNumber = _a.latestVersionNumber;
    var isTestModal = (0, react_1.useState)(false)[0];
    var _b = (0, react_1.useState)(false), newVersion = _b[0], setNewVersion = _b[1];
    var _c = (0, react_1.useState)(0), version = _c[0], setVersion = _c[1];
    var _d = (0, react_1.useState)(""), name = _d[0], setName = _d[1];
    var _e = (0, react_1.useState)(""), description = _e[0], setDescription = _e[1];
    var _f = (0, react_1.useState)(""), smsBody = _f[0], setSmsBody = _f[1];
    var _g = (0, react_1.useState)(currentLob), lob = _g[0], setLob = _g[1];
    var _h = (0, react_1.useState)({
        noName: 0,
        hasSpaces: 0,
        noValue: 0
    }), validationErrors = _h[0], setValidationErrors = _h[1];
    // nameSubjectFlag[0]: check for no name
    // nameSubjectFlag[1]: check for space in name
    var _j = (0, react_1.useState)([0, 0]), nameErrorFlag = _j[0], setNameErrorFlag = _j[1];
    var _k = (0, react_1.useState)(""), kvps = _k[0], setKvps = _k[1];
    var handleKvpChange = function (newKvps) {
        setKvps(newKvps);
    };
    var _l = (0, react_1.useState)(false), noValueFlag = _l[0], setNoValueFlag = _l[1];
    var handleNoValueFlag = function (newFlag) {
        setNoValueFlag(newFlag);
    };
    (0, react_1.useEffect)(function () {
        setLob(currentLob);
    }, [currentLob, open]);
    (0, react_1.useEffect)(function () {
        setName(currentName);
    }, [currentName]);
    (0, react_1.useEffect)(function () {
        setDescription(currentDescription);
    }, [currentDescription]);
    (0, react_1.useEffect)(function () {
        setKvps(currentDefaultSubstitutions ? currentDefaultSubstitutions : "");
    }, [currentDefaultSubstitutions, open]);
    (0, react_1.useEffect)(function () {
        setKvps(kvps);
    }, [kvps]);
    (0, react_1.useEffect)(function () {
        setVersion(currentVersion);
    }, [currentVersion]);
    (0, react_1.useEffect)(function () {
        setNewVersion(latestVersionFlag ? false : true);
    }, [latestVersionFlag]);
    (0, react_1.useEffect)(function () {
        setSmsBody(currentBody);
    }, [currentBody]);
    (0, react_1.useEffect)(function () {
        setNoValueFlag(noValueFlag);
    }, [noValueFlag]);
    var details = {
        name: name,
        description: description,
        version: currentVersion,
        newVersion: newVersion,
        defaultSubstitutions: kvps,
        lob: lob,
    };
    var updateTemplateName = function (e) {
        setName(e.target.value);
        var errorFlag = [0, 0];
        if (!e.target.value.trim()) {
            errorFlag[0] = 1;
        }
        else if (/\s/g.test(e.target.value)) {
            errorFlag[1] = 1;
        }
        setNameErrorFlag(errorFlag);
    };
    var updateTemplateDescription = function (e) {
        setDescription(e.target.value);
    };
    var toggleNewVersion = function () {
        setNewVersion(!newVersion);
    };
    var handleCancel = function () {
        setValidationErrors({
            noName: 0,
            hasSpaces: 0
        });
        setNewVersion(false);
        details = {
            name: "",
            description: "",
            version: 0,
            newVersion: false,
            defaultSubstitutions: "",
            lob: ""
        };
        setName(currentName);
        setDescription(currentDescription);
        setValidationErrors({});
        setNoValueFlag(false);
        setKvps(currentDefaultSubstitutions);
        setNameErrorFlag([0, 0]);
        onClose();
    };
    var checkForSpaces = function (value) {
        if (value)
            return /\s/g.test(value);
    };
    var handleSubmit = function () {
        function validator() {
            return __awaiter(this, void 0, void 0, function () {
                var newErrorObject;
                return __generator(this, function (_a) {
                    newErrorObject = {
                        noName: 0,
                        hasSpaces: 0,
                        noValue: 0
                    };
                    if (!name) {
                        newErrorObject.noName = 1;
                    }
                    if (checkForSpaces(name)) {
                        newErrorObject.hasSpaces = 1;
                    }
                    if (noValueFlag) {
                        newErrorObject.noValue = 1;
                    }
                    setValidationErrors(newErrorObject);
                    if (newErrorObject.noName === 1 || newErrorObject.hasSpaces === 1) {
                        return [2 /*return*/, null];
                    }
                    else {
                        details = {
                            name: name,
                            description: description,
                            version: version,
                            newVersion: newVersion,
                            defaultSubstitutions: kvps,
                            lob: lob
                        };
                        console.log("Values before OnSubmit (Update): ", details);
                        onSubmit(details);
                        setName(currentName);
                        setDescription(currentDescription);
                        setValidationErrors({});
                        setNoValueFlag(false);
                        setKvps(currentDefaultSubstitutions);
                        setNameErrorFlag([0, 0]);
                        onClose();
                    }
                    return [2 /*return*/];
                });
            });
        }
        validator();
    };
    return (React.createElement(material_1.Dialog, { open: open },
        React.createElement(material_1.DialogTitle, { textAlign: "center" }, "Update SMS Template"),
        React.createElement(material_1.DialogContent, null,
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(material_1.Stack, { sx: {
                        width: '100%',
                        minWidth: { xs: '300px', sm: '360px', md: '400px' },
                        gap: '1.5rem',
                    } },
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Template Name"),
                        React.createElement(material_1.TextField, { id: "templatName", sx: { minWidth: '16rem', width: "93%" }, disabled: true, onChange: updateTemplateName, value: name || "", error: name === "" || nameErrorFlag[0] === 1 || nameErrorFlag[1] === 1, helperText: ((name === "" || nameErrorFlag[0] === 1) ? "Please enter a valid Template Name" : "") || ((name === "" || nameErrorFlag[1] === 1) ? "Template Name Contains Spaces" : ""), fullWidth: true })),
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Description"),
                        React.createElement(material_1.TextField, { id: "description", sx: { minWidth: '16rem', width: "93%" }, placeholder: "Optional", onChange: updateTemplateDescription, value: description || "", fullWidth: true })),
                    React.createElement(material_1.Typography, { sx: sxProp_1.helpText },
                        "Current Version: ",
                        currentVersion),
                    latestVersionFlag ?
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } },
                            React.createElement(material_1.Checkbox, { onChange: toggleNewVersion, checked: latestVersionFlag ? newVersion : true, disabled: !latestVersionFlag }),
                            " ",
                            latestVersionFlag ? (!newVersion ? "Create New Version" : ("This will create version  " + (Number(latestVersionNumber) + 1))) : ("This will create version " + (Number(latestVersionNumber) + 1)))
                        :
                            React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont, display: 'flex', color: 'red' } },
                                " This will create version  ",
                                Number(latestVersionNumber) + 1),
                    React.createElement(KVPTable_1.default, { kvps: kvps, newList: [], keyName: "Variable Name", keyLabel: "Value", onKvpChange: handleKvpChange, onNoValueFlagChange: handleNoValueFlag, emailHtmlPart: smsBody, valueCheckAlert: !isTestModal, subject: "" })))),
        React.createElement(material_1.DialogActions, { sx: { p: '1.25rem' } },
            React.createElement(material_1.Button, { sx: sxProp_1.buttonSecondary, onClick: handleCancel }, "Cancel"),
            React.createElement(material_1.Tooltip, { title: !isTestModal ? "Missing Values" : "", disableHoverListener: !noValueFlag },
                React.createElement("span", null,
                    React.createElement(material_1.Button, { sx: sxProp_1.buttonPrimary, onClick: handleSubmit, variant: "contained", disabled: name === "" || nameErrorFlag[0] === 1 || nameErrorFlag[1] === 1 || (!isTestModal && noValueFlag) }, latestVersionFlag ? (!newVersion ? "Update" : "Save as New Version") : "Save as New Version"))))));
};
exports.UpdateTemplateModal = UpdateTemplateModal;
;
var CopyTemplateModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, currentName = _a.currentName, currentDescription = _a.currentDescription, currentDefaultSubstitutions = _a.currentDefaultSubstitutions, currentBody = _a.currentBody, currentLob = _a.currentLob;
    var isTestModal = (0, react_1.useState)(false)[0];
    var _b = (0, react_1.useState)(""), name = _b[0], setName = _b[1];
    var _c = (0, react_1.useState)(""), description = _c[0], setDescription = _c[1];
    var _d = (0, react_1.useState)(""), smsBody = _d[0], setSmsBody = _d[1];
    var _e = (0, react_1.useState)({
        noName: 0,
        hasSpaces: 0
    }), validationErrors = _e[0], setValidationErrors = _e[1];
    // nameSubjectFlag[0]: check for no name
    // nameSubjectFlag[1]: check for space in name
    var _f = (0, react_1.useState)([0, 0]), nameErrorFlag = _f[0], setNameErrorFlag = _f[1];
    var _g = (0, react_1.useState)(currentLob), lob = _g[0], setLob = _g[1];
    var _h = (0, react_1.useState)(""), kvps = _h[0], setKvps = _h[1];
    var handleKvpChange = function (newKvps) {
        setKvps(newKvps);
    };
    var _j = (0, react_1.useState)(false), noValueFlag = _j[0], setNoValueFlag = _j[1];
    var handleNoValueFlag = function (newFlag) {
        setNoValueFlag(newFlag);
    };
    (0, react_1.useEffect)(function () {
        setLob(currentLob);
    }, [currentLob, open]);
    (0, react_1.useEffect)(function () {
        setName(currentName);
    }, [currentName]);
    (0, react_1.useEffect)(function () {
        setDescription(currentDescription);
    }, [currentDescription]);
    (0, react_1.useEffect)(function () {
        setSmsBody(currentBody);
    }, [currentBody, open]);
    (0, react_1.useEffect)(function () {
        setNoValueFlag(noValueFlag);
    }, [noValueFlag]);
    var details = {
        name: name,
        description: description,
        defaultSubstitutions: kvps,
        lob: lob,
    };
    var updateTemplateName = function (e) {
        setName(e.target.value);
        var errorFlag = [0, 0];
        if (!e.target.value.trim()) {
            errorFlag[0] = 1;
        }
        else if (/\s/g.test(e.target.value)) {
            errorFlag[1] = 1;
        }
        setNameErrorFlag(errorFlag);
    };
    var updateTemplateDescription = function (e) {
        setDescription(e.target.value);
    };
    var handleCancel = function () {
        setValidationErrors({
            noName: 0,
            noSubject: 0,
            hasSpaces: 0
        });
        details = {
            name: "",
            description: "",
            defaultSubstitutions: "",
            lob: "",
        };
        setName(currentName);
        setDescription(currentDescription);
        setValidationErrors({});
        setNoValueFlag(false);
        setKvps(currentDefaultSubstitutions);
        setNameErrorFlag([0, 0]);
        onClose();
    };
    var checkForSpaces = function (value) {
        if (value)
            return /\s/g.test(value);
    };
    var checkForCopy = function (value) {
        if (value)
            return /-COPY/g.test(value);
    };
    var handleSubmit = function () {
        function validator() {
            return __awaiter(this, void 0, void 0, function () {
                var newErrorObject;
                return __generator(this, function (_a) {
                    newErrorObject = {
                        noName: 0,
                        hasSpaces: 0,
                        hasCopy: 0
                    };
                    if (!name) {
                        newErrorObject.noName = 1;
                    }
                    if (checkForSpaces(name)) {
                        newErrorObject.hasSpaces = 1;
                    }
                    if (checkForCopy(name)) {
                        newErrorObject.hasCopy = 1;
                    }
                    setValidationErrors(newErrorObject);
                    if (newErrorObject.noName === 1 || newErrorObject.hasSpaces === 1 || newErrorObject.hasCopy === 1) {
                        console.log("Missing Template Name / Contains Spaces / Contains -COPY");
                        return [2 /*return*/, null];
                    }
                    else {
                        details = {
                            name: name,
                            description: description,
                            defaultSubstitutions: kvps,
                            lob: lob,
                        };
                        console.log(details);
                        onSubmit(details);
                        setName(currentName);
                        setDescription(currentDescription);
                        setValidationErrors({});
                        setNoValueFlag(false);
                        setKvps(currentDefaultSubstitutions);
                        setNameErrorFlag([0, 0]);
                        onClose();
                    }
                    return [2 /*return*/];
                });
            });
        }
        validator();
    };
    return (React.createElement(material_1.Dialog, { open: open },
        React.createElement(material_1.DialogTitle, { textAlign: "center" }, "Copy SMS Template"),
        React.createElement(material_1.DialogContent, null,
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(material_1.Stack, { sx: {
                        width: '100%',
                        minWidth: { xs: '300px', sm: '360px', md: '400px' },
                        gap: '1.5rem',
                    } },
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Template Name"),
                        React.createElement(material_1.TextField, { id: "templatName", sx: { minWidth: '16rem', width: "93%" }, onChange: updateTemplateName, value: name || "", error: name === "" || nameErrorFlag[0] === 1 || nameErrorFlag[1] === 1, helperText: ((name === "" || nameErrorFlag[0] === 1) ? "Please enter a valid Template Name" : "") || ((name === "" || nameErrorFlag[1] === 1) ? "Template Name Contains Spaces" : ""), fullWidth: true }),
                        validationErrors.noName === 1 &&
                            React.createElement(material_1.Typography, { key: 'NameError', sx: sxProp_1.errorText }, "Please enter a Template Name"),
                        validationErrors.hasSpaces === 1 &&
                            React.createElement(material_1.Typography, { key: 'NameError', sx: sxProp_1.errorText }, "Template Name cannot contain spaces"),
                        validationErrors.hasCopy === 1 &&
                            React.createElement(material_1.Typography, { key: 'NameError', sx: sxProp_1.errorText }, "Template Name must be renamed")),
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Description"),
                        React.createElement(material_1.TextField, { id: "description", sx: { minWidth: '16rem', width: "93%" }, placeholder: "Optional", onChange: updateTemplateDescription, value: description || "", fullWidth: true })),
                    React.createElement(KVPTable_1.default, { kvps: currentDefaultSubstitutions, newList: [], keyName: "Variable Name", keyLabel: "Value", onKvpChange: handleKvpChange, onNoValueFlagChange: handleNoValueFlag, emailHtmlPart: smsBody, valueCheckAlert: !isTestModal, subject: "" })))),
        React.createElement(material_1.DialogActions, { sx: { p: '1.25rem' } },
            React.createElement(material_1.Button, { sx: sxProp_1.buttonSecondary, onClick: handleCancel }, "Cancel"),
            React.createElement(material_1.Tooltip, { title: !isTestModal ? "Missing Values" : "", disableHoverListener: !noValueFlag },
                React.createElement("span", null,
                    React.createElement(material_1.Button, { sx: sxProp_1.buttonPrimary, onClick: handleSubmit, variant: "contained", disabled: name === "" || nameErrorFlag[0] === 1 || nameErrorFlag[1] === 1 || (!isTestModal && noValueFlag) }, "Copy"))),
            "            ")));
};
exports.CopyTemplateModal = CopyTemplateModal;
;
var TestTemplateModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, onSubmit = _a.onSubmit, currentName = _a.currentName, currentDescription = _a.currentDescription, currentDefaultSubstitutions = _a.currentDefaultSubstitutions, currentBody = _a.currentBody, currentProjectId = _a.currentProjectId;
    var isTestModal = (0, react_1.useState)(true)[0];
    var _b = (0, react_1.useState)(""), appId = _b[0], setAppId = _b[1];
    var _c = (0, react_1.useState)(""), name = _c[0], setName = _c[1];
    var _d = (0, react_1.useState)(""), sendSmsTo = _d[0], setSendSmsTo = _d[1];
    var _e = (0, react_1.useState)(""), sendSmsFrom = _e[0], setSendSmsFrom = _e[1];
    // smsValidationFlag[0]: no value error
    // smsValidationFlag[1]: longer than 10 digits error
    // smsValidationFlag[2]: not starts with 1 when it's 10 digits error
    // const [smsValidationFlag, setSmsValidationFlag] = useState<number[]>([0, 0, 0])
    var _f = (0, react_1.useState)(""), smsValidationMessage = _f[0], setSmsValidationMessage = _f[1];
    var _g = (0, react_1.useState)(""), description = _g[0], setDescription = _g[1];
    var _h = (0, react_1.useState)({}), defaultSubstitutions = _h[0], setDefaultSubstitutions = _h[1];
    var _j = (0, react_1.useState)(""), smsBody = _j[0], setSmsBody = _j[1];
    var _k = (0, react_1.useState)("TRANSACTIONAL"), messageType = _k[0], setMessageType = _k[1];
    var _l = (0, react_1.useState)({
        noName: 0,
        noSendSmsTo: 0,
        hasSpaces: 0,
        noValue: 0,
    }), validationErrors = _l[0], setValidationErrors = _l[1];
    var _m = (0, react_1.useState)(""), kvps = _m[0], setKvps = _m[1];
    var _o = (0, react_1.useState)(defaultSubstitutions), kvpsJson = _o[0], setKvpsJson = _o[1];
    var handleKvpChange = function (newKvps) {
        setKvps(newKvps);
    };
    var _p = (0, react_1.useState)(false), noValueFlag = _p[0], setNoValueFlag = _p[1];
    var handleNoValueFlag = function (newFlag) {
        setNoValueFlag(newFlag);
    };
    (0, react_1.useEffect)(function () {
        setAppId(currentProjectId);
    }, [currentProjectId]);
    (0, react_1.useEffect)(function () {
        setName(currentName);
    }, [currentName]);
    (0, react_1.useEffect)(function () {
        setDescription(currentDescription);
    }, [currentDescription]);
    (0, react_1.useEffect)(function () {
        setSmsBody(currentBody);
    }, [currentBody]);
    (0, react_1.useEffect)(function () {
        var defaultSubstitutionsJson = {};
        defaultSubstitutionsJson = currentDefaultSubstitutions ? JSON.parse(currentDefaultSubstitutions) : {};
        setDefaultSubstitutions(defaultSubstitutionsJson);
        setKvpsJson(defaultSubstitutionsJson);
    }, [currentDefaultSubstitutions, open]);
    (0, react_1.useEffect)(function () {
        var substitutionsJsonTemp = {};
        try {
            substitutionsJsonTemp = kvps ? JSON.parse(kvps) : {};
        }
        catch (_a) {
            console.log("Error kvps: ", kvps);
        }
        var substitutionsJson = substitutionsJsonTemp ? Object.keys(substitutionsJsonTemp).reduce(function (acc, key) {
            acc[key] = [substitutionsJsonTemp[key]];
            return acc;
        }, {}) : {};
        setKvpsJson(substitutionsJson);
    }, [kvps, smsBody, open]);
    (0, react_1.useEffect)(function () {
        setSendSmsTo(sendSmsTo);
    }, [sendSmsTo]);
    (0, react_1.useEffect)(function () {
        setNoValueFlag(noValueFlag);
    }, [noValueFlag]);
    /*useEffect(() => {
        setSmsValidationFlag(smsValidationFlag);
    }, [smsValidationFlag, kvpsJson])*/
    /*    useEffect(() => {
            setSmsValidationMessage(smsValidationMessage);
        }, [smsValidationMessage, kvpsJson])*/
    var details = {
        appId: appId,
        name: name,
        defaultSubstitutions: defaultSubstitutions,
        sendSmsTo: sendSmsTo,
        sendSmsFrom: sendSmsFrom,
        description: description,
        messageType: messageType,
    };
    var updateTemplateName = function (e) {
        setName(e.target.value);
    };
    var updateTemplateDescription = function (e) {
        setDescription(e.target.value);
    };
    var updateTemplateSendSmsTo = function (e) {
        setSendSmsTo(e.target.value);
        if (!e.target.value) {
            setSmsValidationMessage("Please enter a valid phone number or short code");
        }
        else if ((e.target.value.length > 6 && e.target.value.length < 11) || e.target.value.length > 11) {
            setSmsValidationMessage("Phone number should be 11 digits");
        }
        else if (e.target.value.length === 11 && !/^1/.test(e.target.value)) {
            setSmsValidationMessage("Phone number should start with 1");
        }
        else if (e.target.value.length < 7 && !/^\d{5,6}$/.test(e.target.value)) {
            setSmsValidationMessage("Short code should have 5 or 6 digits");
        }
        else {
            setSmsValidationMessage("");
        }
    };
    var handleMessageTypeChange = function (e) {
        setMessageType(e.target.value);
    };
    var handleCancel = function () {
        setValidationErrors({
            noName: 0,
            noSubject: 0,
            noSendSmsTo: 0,
            hasSpaces: 0,
            noValue: 0,
        });
        details = {
            appId: "",
            name: "",
            defaultSubstitutions: {},
            sendSmsTo: "",
            sendSmsFrom: "",
            description: "",
            messageType: "TRANSACTIONAL",
        };
        setSendSmsTo("");
        setKvps("");
        setKvpsJson({});
        setSmsBody(currentBody);
        setValidationErrors({});
        setNoValueFlag(false);
        setSmsValidationMessage("");
        onClose();
        setMessageType("TRANSACTIONAL");
    };
    var checkForSpaces = function (value) {
        if (value)
            return /\s/g.test(value);
    };
    var handleSubmit = function () {
        function validator() {
            return __awaiter(this, void 0, void 0, function () {
                var newErrorObject;
                return __generator(this, function (_a) {
                    newErrorObject = {
                        noName: 0,
                        noSendSmsTo: 0,
                        hasSpaces: 0,
                        noValue: 0,
                    };
                    if (!name) {
                        newErrorObject.noName = 1;
                    }
                    if (!sendSmsTo) {
                        newErrorObject.noSendSmsTo = 1;
                    }
                    if (checkForSpaces(name)) {
                        newErrorObject.hasSpaces = 1;
                    }
                    if (noValueFlag) {
                        newErrorObject.noValue = 1;
                    }
                    setValidationErrors(newErrorObject);
                    if (newErrorObject.noName === 1) {
                        console.log("Missing -- Template Name");
                        return [2 /*return*/, null];
                    }
                    else if (newErrorObject.hasSpaces === 1) {
                        console.log("SMS Template Contains Spaces");
                        return [2 /*return*/, null];
                    }
                    else if (newErrorObject.noSendSmsTo === 1) {
                        console.log("Missing -- Send Sms To");
                        return [2 /*return*/, null];
                    }
                    else if (!isTestModal && newErrorObject.noValue === 1) {
                        console.log("Missing -- Values for Attributess");
                        setNoValueFlag(true);
                        return [2 /*return*/, null];
                    }
                    else {
                        details = {
                            appId: appId,
                            name: name,
                            defaultSubstitutions: kvpsJson,
                            sendSmsTo: sendSmsTo,
                            sendSmsFrom: sendSmsFrom,
                            description: description,
                            messageType: messageType,
                        };
                        onSubmit(details);
                        setSendSmsTo("");
                        setKvps("");
                        setKvpsJson({});
                        setSmsBody(currentBody);
                        setValidationErrors({});
                        setNoValueFlag(false);
                        setSmsValidationMessage("");
                        setMessageType("TRANSACTIONAL");
                        onClose();
                    }
                    return [2 /*return*/];
                });
            });
        }
        validator();
    };
    return (React.createElement(material_1.Dialog, { open: open },
        React.createElement(material_1.DialogTitle, { textAlign: "center" }, "Test SMS Template"),
        React.createElement(material_1.DialogContent, null,
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(material_1.Stack, { sx: {
                        width: '100%',
                        minWidth: { xs: '300px', sm: '360px', md: '400px' },
                        gap: '1.5rem',
                    } },
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Send Test SMS To"),
                        React.createElement(material_1.TextField, { id: "sendSmsTo", sx: { minWidth: '16rem', width: "93%" }, required: true, inputProps: { type: "number", }, onChange: updateTemplateSendSmsTo, value: sendSmsTo || "", error: sendSmsTo === "" || smsValidationMessage !== "", helperText: sendSmsTo === "" ? "Please enter a valid phone number or short code" : smsValidationMessage, fullWidth: true })),
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Template Name"),
                        React.createElement(material_1.TextField, { id: "templatName", sx: { minWidth: '16rem', width: "93%" }, disabled: true, inputProps: { readOnly: true, }, onChange: updateTemplateName, value: name || "", fullWidth: true })),
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Description"),
                        React.createElement(material_1.TextField, { id: "description", sx: { minWidth: '16rem', width: "93%" }, disabled: true, placeholder: "Optional", inputProps: { readOnly: true, }, onChange: updateTemplateDescription, value: description || "", fullWidth: true })),
                    React.createElement(material_1.Grid, { item: true, xs: 12 },
                        React.createElement(material_1.FormControl, { component: "fieldset" },
                            React.createElement(material_1.Typography, { sx: { fontFamily: sxProp_1.dishFont } }, "Message Type"),
                            React.createElement(material_1.RadioGroup, { row: true, value: messageType, onChange: handleMessageTypeChange },
                                React.createElement(material_1.Grid, { item: true, xs: 12 },
                                    React.createElement(material_1.FormControlLabel, { value: "TRANSACTIONAL", control: React.createElement(material_1.Radio, null), label: "Transactional" }),
                                    React.createElement(material_1.FormHelperText, { style: { marginLeft: 32 } }, "Critical or time-sensitive messages")),
                                React.createElement(material_1.Grid, { item: true, xs: 12 },
                                    React.createElement(material_1.FormControlLabel, { value: "PROMOTIONAL", control: React.createElement(material_1.Radio, null), label: "Promotional" }),
                                    React.createElement(material_1.FormHelperText, { style: { marginLeft: 32 } }, "Non-critical messages, including marketing messages"))))),
                    React.createElement(KVPTable_1.default, { kvps: JSON.stringify(defaultSubstitutions), newList: [], keyName: "Variable Name", keyLabel: "Value", onKvpChange: handleKvpChange, onNoValueFlagChange: handleNoValueFlag, emailHtmlPart: smsBody, valueCheckAlert: !isTestModal, subject: "" })))),
        React.createElement(material_1.DialogActions, { sx: { p: '1.25rem' } },
            React.createElement(material_1.Button, { sx: sxProp_1.buttonSecondary, onClick: handleCancel }, "Cancel"),
            React.createElement(material_1.Tooltip, { title: !isTestModal ? "Missing Values" : "", disableHoverListener: !noValueFlag },
                React.createElement("span", null,
                    React.createElement(material_1.Button, { sx: sxProp_1.buttonPrimary, onClick: handleSubmit, variant: "contained", disabled: isTestModal && (sendSmsTo === "" || smsValidationMessage !== "" || noValueFlag) }, "Test"))))));
};
exports.TestTemplateModal = TestTemplateModal;
exports.default = SMSTemplateCreate;
